import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/70">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2">
        <div className="relative">
          <div className="relative h-[260px] w-full overflow-hidden rounded-lg md:h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20digital%20shopping%20list%20on%20a%20tablet%20showing%20product%20catalog%20rows%20with%20small%20sneaker%20and%20hoodie%20thumbnails%20clean%20minimal%20workspace%20warm%20cream%20background%20soft%20light%20premium%20editorial%20style%20high%20detail&width=800&height=600&seq=usfans-sheet-02&orientation=landscape"
              alt="USFans Spreadsheet overview"
              title="USFans Spreadsheet overview"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div>
          <span className="text-xs font-bold tracking-widest text-primary-600">{t('about_eyebrow')}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t('about_title')}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('about_desc')}</p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            {t('about_cta')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}